import { FieldRenderProps } from 'react-final-form'
import React from 'react'
import TextField from '@cinch/design-system/src/components/forms/field-text/field-text.component'
import { ErrorDisplayOptions } from '../../types'
import { FormFieldErrorProps } from '@somo/oxd-apps-design-system/src/components/forms/field-error/field-error.component'

const onSubmitError = (meta: FieldRenderProps['meta']): FormFieldErrorProps => {
  const { touched, valid, submitFailed, submitError, submitting, error } = meta
  return {
    show: !!(submitFailed && !valid && touched && !submitting),
    message: error || submitError,
  }
}

const realTimeError = (meta: FieldRenderProps['meta']): FormFieldErrorProps => {
  const { touched, error, submitError, dirtySinceLastSubmit, submitting } = meta
  return {
    show: touched && (error || (submitError && !dirtySinceLastSubmit)) && !submitting,
    message: error || submitError,
  }
}

const getError = (errorDisplay: ErrorDisplayOptions, meta: FieldRenderProps['meta']): FormFieldErrorProps => {
  switch (errorDisplay) {
    case 'onSubmit':
      return onSubmitError(meta)
    case 'realtime':
    default:
      return realTimeError(meta)
  }
}

export interface TextFieldWrapperProps extends FieldRenderProps {
  errorDisplay?: ErrorDisplayOptions

  [k: string]: any
}

const TextFieldWrapper: React.FC<TextFieldWrapperProps> = ({ errorDisplay = 'realtime', input, meta, ...rest }) => {
  const error = getError(errorDisplay, meta)
  return (
    <TextField
      {...rest}
      id={rest.id}
      name={input.name}
      type={rest.type}
      value={input.value}
      onChange={input.onChange}
      onBlur={input.onBlur}
      onFocus={input.onFocus}
      oxdValid={!error.show && meta?.touched && meta?.valid}
      error={error}
    />
  )
}

export default TextFieldWrapper
